<template>
  <div>
    <el-collapse v-model="sizeActiveNames">
      <el-collapse-item title="尺寸" name="1">
        <template slot="title">
          尺寸
          <div
            class="add-size"
            @click.stop
            v-if="(showMinMax && widthType === '自动' && (!showMaxWidth || !showMinWidth)) || showMinMaxHeight && (!showMaxHeight || !showMinHeight)"
          >
            <el-dropdown @command="addHandleCommand" trigger="click">
              <span class="el-dropdown-link icon-portal-plus"></span>
              <el-dropdown-menu slot="dropdown" class="custom-menu">
                <el-dropdown-item
                  v-for="(size, index) in newSizeLists"
                  :key="'size' + index"
                  :command="size.value"
                  v-show="size.show"
                  ><span class="icon" :class="size.icon"></span>{{ size.label }}</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </template>
        <div class="content clearFloat">
          <div class="verticallyCenter">
            <div class="verticallyCenter mr12">
              <span class="fs14 mr8">宽</span>
              <el-input
                :type="widthType === 'px' ? 'number' : ''"
                class="input-size"
                placeholder="-"
                v-model="value1"
                @blur="blurEvent('originValue1', 'value1')"
                @focus="getFocus($event)"
                @input="inputEvent"
                @change="changeEvent"
                @keyup.native="keyupEvent($event, 'originValue1', 'value1')"
                @wheel.native.prevent
                :disabled="disabledWidth"
              >
                <template slot="suffix">
                  <el-dropdown trigger="click" @command="widthTypeHandleCommand" v-if="!disabledWidthAll">
                    <span class="el-dropdown-link lineHeight32" v-if="widthType === 'px'">
                      {{ widthType }}
                    </span>
                    <span class="el-dropdown-link lineHeight32" :class="widthIcon" v-else></span>
                    <el-dropdown-menu slot="dropdown" class="dropdown-size">
                      <el-dropdown-item
                        v-for="(sizeType, index) in showWidthTypes"
                        :command="sizeType.value"
                        :key="'sizeType_' + index"
                      >
                        <span
                          class="selected-icon"
                          :class="widthType === sizeType.value ? 'icon-portal-check-small' : ''"
                        ></span>
                        {{ sizeType.label }}
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                  <span class="suffix lineHeight32" v-else>
                    {{ widthType }}
                  </span>
                </template>
              </el-input>
            </div>
            <div class="verticallyCenter">
              <span class="fs14 mr8">高</span>
              <el-input
                :type="heightType === 'px' ? 'number' : ''"
                class="input-size"
                placeholder="-"
                v-model="value2"
                @blur="blurEvent('originValue2', 'value2')"
                @focus="getFocus($event)"
                @input="inputEvent"
                @change="changeEvent"
                @keyup.native="keyupEvent($event, 'originValue2', 'value2')"
                @wheel.native.prevent
                :disabled="disabledHeight"
              >
                <template slot="suffix">
                  <el-dropdown trigger="click" @command="heightTypeHandleCommand">
                    <span class="el-dropdown-link lineHeight32" v-if="heightType === 'px'">
                      {{ heightType }}
                    </span>
                    <span class="el-dropdown-link lineHeight32" :class="heightIcon" v-else></span>
                    <el-dropdown-menu slot="dropdown" class="dropdown-size">
                      <el-dropdown-item
                        v-for="(sizeType, index) in showHeightTypes"
                        :key="index"
                        :command="sizeType.value"
                      >
                        <span
                          class="selected-icon"
                          :class="heightType === sizeType.value ? 'icon-portal-check-small' : ''"
                        ></span>
                        {{ sizeType.label }}
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </template>
              </el-input>
            </div>
          </div>
          <div class="verticallyStart" v-if="showMinMax || showMinMaxHeight">
            <div style="width: 50%; padding-right: 6px">
              <div class="verticallyCenter mt8" v-if="showMaxWidth">
                <span class="fs14 mr8 icon-portal-max-width"></span>
                <el-input
                  class="input-size"
                  placeholder="最大宽"
                  v-model="tempMaxWidth"
                  @blur="blurEvent('maxWidth', 'tempMaxWidth')"
                  @keyup.native="keyupEvent($event, 'maxWidth', 'tempMaxWidth')"
                  @focus="getFocus($event)"
                >
                  <template slot="suffix">
                    <el-dropdown trigger="click" @command="delHandleCommand('showMaxWidth', 'maxWidth')">
                      <span class="el-dropdown-link lineHeight32">px</span>
                      <el-dropdown-menu slot="dropdown" class="custom-menu">
                        <el-dropdown-item>
                          <span class="icon icon-portal-close-small"></span>移除最大宽度
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </template>
                </el-input>
              </div>
              <div class="verticallyCenter mt8" v-if="showMinWidth">
                <span class="fs14 mr8 icon-portal-min-width"></span>
                <el-input
                  class="input-size"
                  placeholder="最小宽"
                  v-model="tempMinWidth"
                  @blur="blurEvent('minWidth', 'tempMinWidth')"
                  @keyup.native="keyupEvent($event, 'minWidth', 'tempMinWidth')"
                  @focus="getFocus($event)"
                >
                  <template slot="suffix">
                    <el-dropdown trigger="click" @command="delHandleCommand('showMinWidth', 'minWidth')">
                      <span class="el-dropdown-link lineHeight32">px</span>
                      <el-dropdown-menu slot="dropdown" class="custom-menu">
                        <el-dropdown-item>
                          <span class="icon icon-portal-close-small"></span>移除最小宽度
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </template>
                </el-input>
              </div>
            </div>
            <div style="width: 50%; padding-left: 6px" v-if="showMinMaxHeight">
              <div class="verticallyCenter mt8" v-if="showMaxHeight">
                <span class="fs14 mr8 icon-portal-max-height"></span>
                <el-input
                  class="input-size"
                  placeholder="最大高"
                  v-model="tempMaxHeight"
                  @blur="blurEvent('maxHeight', 'tempMaxHeight')"
                  @keyup.native="keyupEvent($event, 'maxHeight', 'tempMaxHeight')"
                  @focus="getFocus($event)"
                >
                  <template slot="suffix">
                    <el-dropdown trigger="click" @command="delHandleCommand('showMaxHeight', 'maxHeight')">
                      <span class="el-dropdown-link lineHeight32">px</span>
                      <el-dropdown-menu slot="dropdown" class="custom-menu">
                        <el-dropdown-item>
                          <span class="icon icon-portal-close-small"></span>移除最大高度
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </template>
                </el-input>
              </div>
              <div class="verticallyCenter mt8" v-if="showMinHeight">
                <span class="fs14 mr8 icon-portal-min-height"></span>
                <el-input
                  class="input-size"
                  placeholder="最小高"
                  v-model="tempMinHeight"
                  @blur="blurEvent('minHeight', 'tempMinHeight')"
                  @keyup.native="keyupEvent($event, 'minHeight', 'tempMinHeight')"
                  @focus="getFocus($event)"
                >
                  <template slot="suffix">
                    <el-dropdown trigger="click" @command="delHandleCommand('showMinHeight', 'minHeight')">
                      <span class="el-dropdown-link lineHeight32">px</span>
                      <el-dropdown-menu slot="dropdown" class="custom-menu">
                        <el-dropdown-item>
                          <span class="icon icon-portal-close-small"></span>移除最小高度
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </template>
                </el-input>
              </div>
            </div>
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import { historyCombineWrap } from "utils/revork"
export default {
  components: {},
  props: {
    widthVal: {
      type: Number,
      default: null
    },
    heightVal: {
      type: Number,
      default: null
    },
    widthAuto: {
      type: Boolean,
      default: true
    },
    heightAuto: {
      type: Boolean,
      default: true
    },
    showMinMax: {
      type: Boolean,
      default: false
    },
    showMaxWidth1: {
      type: Boolean,
      default: true
    },
    showMinWidth1: {
      type: Boolean,
      default: true
    },
    maxWidth1: {
      type: Number,
      default: null
    },
    minWidth1: {
      type: Number,
      default: null
    },
    disableWidthAuto: {
      type: Boolean,
      default: false
    },
    disableWidthFull: {
      type: Boolean,
      default: true
    },
    disableHeightAuto: {
      type: Boolean,
      default: false
    },
    disableHeightFull: {
      type: Boolean,
      default: true
    },
    widthFull: {
      type: Boolean,
      default: false
    },
    heightFull: {
      type: Boolean,
      default: false
    },
    showMinMaxHeight: {
      type: Boolean,
      default: false
    },
    disabledWidthAll: {
      type: Boolean,
      default: false
    },
    showMaxHeight1: {
      type: Boolean,
      default: true
    },
    showMinHeight1: {
      type: Boolean,
      default: true
    },
    maxHeight1: {
      type: Number,
      default: null
    },
    minHeight1: {
      type: Number,
      default: null
    },
  },
  data() {
    return {
      sizeActiveNames: ["1", "2"],
      widthTypes: [
        {
          label: "固定宽度",
          value: "px"
        },
        {
          label: "适应内容",
          value: "自动", // 该名称是为了直接用之前的逻辑不能修改
          icon: "icon-portal-auto-width"
        },
        {
          label: "充满布局",
          value: "充满",
          icon: "icon-portal-fill-width"
        }
      ],
      heightTypes: [
        {
          label: "固定高度",
          value: "px"
        },
        {
          label: "适应内容",
          value: "自动", // 该名称是为了直接用之前的逻辑不能修改
          icon: "icon-portal-hug-height"
        },
        {
          label: "充满布局",
          value: "充满",
          icon: "icon-portal-fill-height"
        }
      ],
      isFocus: false,
      value1: 0,
      value2: 0,
      sizeLists: [
        {
          label: "最大宽度",
          value: "showMaxWidth",
          icon: "icon-portal-max-width",
          show: true
        },
        {
          label: "最小宽度",
          value: "showMinWidth",
          icon: "icon-portal-min-width",
          show: true
        }
      ],
      heightSizeList: [{
        label: "最大高度",
        value: "showMaxHeight",
        icon: "icon-portal-max-height",
        show: true
      }, {
        label: "最小高度",
        value: "showMinHeight",
        icon: "icon-portal-min-height",
        show: true
      }],
      tempMinWidth: 0,
      tempMaxWidth: 0,
      tempMinHeight: 0,
      tempMaxHeight: 0
    }
  },
  watch: {
    originValue1(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.value1 = newVal
      }
    },
    originValue2(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.value2 = newVal
      }
    },
    minWidth(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.tempMinWidth = newVal
      }
    },
    maxWidth(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.tempMaxWidth = newVal
      }
    },
    minHeight(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.tempMinHeight = newVal
      }
    },
    maxHeight(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.tempMaxHeight = newVal
      }
    }
  },
  computed: {
    newSizeLists() {
      console.log('this.showMinMaxHeight :>>',this.showMinMaxHeight,this.showMinMax );
      let sizeLists = JSON.parse(JSON.stringify(this.sizeLists))
      if (this.showMinMaxHeight) {
        sizeLists = this.showMinMax ? sizeLists.concat(this.heightSizeList) : this.heightSizeList
      }
      sizeLists.forEach(item => {
        Object.assign(item, {          
          show: !this[item.value]
        })
      })
      return sizeLists
    },
    showWidthTypes() {
      let widthTypes = this.widthTypes
      if (this.disableWidthFull) {
        widthTypes = widthTypes.filter(item => item.value !== "充满")
      }
      if (this.disableWidthAuto) {
        widthTypes = widthTypes.filter(item => item.value !== "自动")
      }
      return widthTypes
    },
    showHeightTypes() {
      let heightTypes = this.heightTypes
      if (this.disableHeightFull) {
        heightTypes = heightTypes.filter(item => item.value !== "充满")
      }
      if (this.disableHeightAuto) {
        heightTypes = heightTypes.filter(item => item.value !== "自动")
      }
      return heightTypes
    },
    widthType: {
      get() {
        if (this.disabledWidthAll) {
          return this.widthAuto ? "-" : this.widthFull ? "%" : ""
        }
        return this.widthAuto ? "自动" : this.widthFull ? "充满" : "px"
      },
      set(newVal) {
        let ifAuto = true
        let ifFull = true
        if (newVal === "px") {
          ifAuto = false
          ifFull = false
        } else if (newVal === "充满") {
          ifAuto = false
          ifFull = true
        } else {
          ifFull = false
        }
        historyCombineWrap(() => {
          this.$emit("update:widthAuto", ifAuto)
          this.$emit("update:widthFull", ifFull)
        })()
      }
    },
    heightType: {
      get() {
        return this.heightAuto ? "自动" : this.heightFull ? "充满" : "px"
      },
      set(newVal) {
        let ifAuto = true
        let ifFull = true
        if (newVal === "px") {
          ifAuto = false
          ifFull = false
        } else if (newVal === "充满") {
          ifAuto = false
          ifFull = true
        } else {
          ifFull = false
        }
        historyCombineWrap(() => {
          this.$emit("update:heightAuto", ifAuto)
          this.$emit("update:heightFull", ifFull)
        })()
      }
    },
    originValue1: {
      get() {
        if (this.disabledWidthAll) {
          if (this.widthAuto) return "自动"
          if (this.widthFull) return "100"
        }
        if (this.widthType === "自动") {
          return "适应"
        } else if (this.widthType === "充满") {
          return "充满"
        } else {
          return this.widthVal
        }
      },
      set(newVal) {
        newVal = newVal < 1 ? 1 : newVal
        this.$emit("update:widthVal", Number(newVal))
      }
    },
    originValue2: {
      get() {
        if (this.heightType === "自动") {
          return "适应"
        } else if (this.heightType === "充满") {
          return "充满"
        } else {
          return this.heightVal
        }
      },
      set(newVal) {
        newVal = newVal < 1 ? 1 : newVal
        this.$emit("update:heightVal", Number(newVal))
      }
    },
    disabledWidth() {
      if (this.widthType === "自动" || this.widthType === "充满" || this.disabledWidthAll) {
        return true
      } else {
        return false
      }
    },
    disabledHeight() {
      if (this.heightType === "自动" || this.heightType === "充满") {
        return true
      } else {
        return false
      }
    },
    widthIcon() {
      return this.widthTypes?.find(item => item.value === this.widthType)?.icon
    },
    heightIcon() {
      return this.heightTypes?.find(item => item.value === this.heightType)?.icon
    },
    showMaxWidth: {
      get() {
        return this.showMaxWidth1
      },
      set(newVal) {
        this.$emit("update:showMaxWidth1", newVal)
      }
    },
    showMinWidth: {
      get() {
        return this.showMinWidth1
      },
      set(newVal) {
        this.$emit("update:showMinWidth1", newVal)
      }
    },
    maxWidth: {
      get() {
        return this.maxWidth1
      },
      set(newVal) {
        this.$emit("update:maxWidth1", newVal)
      }
    },
    minWidth: {
      get() {
        return this.minWidth1
      },
      set(newVal) {
        this.$emit("update:minWidth1", newVal)
      }
    },
    showMaxHeight: {
      get() {
        return this.showMaxHeight1
      },
      set(newVal) {
        this.$emit("update:showMaxHeight1", newVal)
      }
    },
    showMinHeight: {
      get() {
        return this.showMinHeight1
      },
      set(newVal) {
        this.$emit("update:showMinHeight1", newVal)
      }
    },
    maxHeight: {
      get() {
        return this.maxHeight1
      },
      set(newVal) {
        this.$emit("update:maxHeight1", newVal)
      }
    },
    minHeight: {
      get() {
        return this.minHeight1
      },
      set(newVal) {
        this.$emit("update:minHeight1", newVal)
      }
    }
  },
  mounted() {
    this.initData()
  },
  methods: {
    widthTypeHandleCommand(val) {
      if (this.widthType === val) {
        return
      }
      this.widthType = val
      if (val === "自动" || val === "充满") {
        if (this.widthVal === undefined) {
          this.originValue1 = 400
        }
      } else {
        this.originValue1 = this.widthVal || 400
      }
      this.newSizeLists.forEach(item => {
        Object.assign(item, {          
          show: !this[item.value]
        })
      })
    },
    heightTypeHandleCommand(val) {
      if (this.heightType === val) {
        return
      }
      this.heightType = val
      if (val === "自动" || val === "充满") {
        if (this.heightVal === undefined) {
          this.originValue2 = 200
        }
      } else {
        this.originValue2 = this.heightVal || 200
      }
      this.newSizeLists.forEach(item => {
        Object.assign(item, {          
          show: !this[item.value]
        })
      })
    },
    initData() {
      this.value1 = this.originValue1
      this.value2 = this.originValue2
      this.tempMinWidth = this.minWidth
      this.tempMaxWidth = this.maxWidth
    },
    getFocus(event) {
      this.isFocus = true
      event.currentTarget.select()
    },
    blurEvent(obj1, obj2) {
      this.isFocus = false
      this.setValue(obj1, obj2)
    },
    inputEvent() {
      this.$emit("input")
    },
    changeEvent() {
      this.$emit("change")
    },
    keyupEvent(e, obj1, obj2) {
      this.$emit("keyup", e)
      this.keyDownEvent(e, obj1, obj2)
    },
    keyDownEvent(e, obj1, obj2) {
      let key = window.event.keyCode
      //enter键  待完善
      if ((key === 38 || key === 40) && this.isFocus) {
        e.target.select()
        setTimeout(() => {
          this.setValue(obj1, obj2)
        }, 50)
      }
    },
    setValue(originName, name) {
      if (this[name]) {
        let val = Number(this[name])
        if (Number(this.max) && val > this.max) {
          this[name] = this.max
        }
        if (Number(this.min) && val < this.min) {
          this[name] = this.min
        }
        this[originName] = val
      } else {
        // 不允许输入为空 为空的情况恢复原来的值
        this[name] = Number(this[originName])
      }
      this.$nextTick(() => {
        this.$emit("changeValue")
      })
    },
    addHandleCommand(command, type, index) {
      console.log("command :>>", command, type, index)
      if (!command) return
      this[command] = true
      this.newSizeLists.forEach(item => {
        if (item.value === command) {
          item.show = false
        }
      })
    },
    delHandleCommand(val, name) {
      console.log("val :>>", val)
      this[val] = false
      this[name] = null
      this.newSizeLists.forEach(item => {
        if (item.value === val) {
          item.show = true
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.lineHeight32 {
  display: inline-block;
  line-height: 32px;
}

::v-deep .el-dropdown-link {
  color: var(--subTextColor) !important;
}

::v-deep .input-size .el-input__suffix {
  right: 4px;
}

::v-deep .input-size .el-dropdown-link {
  width: 24px;
  height: 24px;
  line-height: 24px;
  border-radius: 3px;
  margin: 4px 0;
}

::v-deep .input-size .el-dropdown-link:hover {
  background: var(--paddingIconHoverColor);
}

::v-deep .input-size.el-input.is-disabled .el-input__inner {
  background: var(--inputBackGround) !important;
}

.selected-icon {
  position: absolute;
  top: 50%;
  left: 12px;
  font-size: 16px;
  color: var(--themeColor);
  transform: translateY(-50%);
}

.dropdown-size {
  margin-top: -32px;
}

.dropdown-size li {
  position: relative;
  width: 100px;
  padding-left: 36px;
  padding-right: 12px;
}

.el-dropdown-menu__item {
  color: var(--textColor);
  font-size: 13px;
}

.title-icon {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--textColor);
  font-size: 16px;
}

.custom-menu {
  .el-dropdown-menu__item {
    line-height: 38px;
    padding: 0 12px;

    .icon {
      display: inline-block;
      vertical-align: top;
      margin-top: 10px;
      font-size: 16px;
      margin-right: 8px;
    }
  }
}

.add-size {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);

  .el-dropdown-link {
    display: inline-block;
    width: 24px;
    height: 24px;
    border-radius: 4px;
    text-align: center;
    line-height: 24px;

    &:hover {
      background: rgba(31, 35, 41, 0.08);
    }
  }
}
.suffix {
  width: 24px;
  height: 24px;
  line-height: 24px;
  margin: 4px 0;
  color: var(--inputDisabledColor);
}
</style>
